import React, { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { getWebHookSenderLogAsync, checkedState, unCheckedState, setSortConfig, getHeadingAsync, getAccountWebHookSenderLogAsync,updateSorting, checkedAllState, unCheckedAllState } from './WebHookSenderLogSlice';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import '../../../common/css/timeLive.css'
import { getValueFromResource } from '../../../common/timeLiveFunction';
const WebHookSenderLogItem = (props: any) => {
    const { webhooksenderlogid, onhandleFilterOnClickEvent, offCanvasObject, t } = props;
    const dispatch = useAppDispatch();
    const { WebHookSenderLogList, isReload, pageSize, totalItems,pageNo,startRec, recordsFiltered,sortColumn,sortOrder, search,
        optionStatusValue, optionWebHookEventTypeValue, startDate, endDate,isLoading
    } = useAppSelector((state) => state.webHookSenderLog);
    const navigate = useNavigate();

    const isGuid = (stringToTest: any) => {
        if (stringToTest[0] === "{") {
            stringToTest = stringToTest.substring(1, stringToTest.length - 1);
        }
        var regexGuid = /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
        var x = regexGuid.test(stringToTest);
        return x;
    };

    useEffect(() => {
        if (isReload) {
            if (webhooksenderlogid !== null) {
                if (isGuid(webhooksenderlogid)) {
                    dispatch(getHeadingAsync(webhooksenderlogid));
                    let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
                    dispatch(getAccountWebHookSenderLogAsync());
                }
                else {
                    navigate('/webHooks');
                }
            }
            else {
                navigate('/webHooks');
            }
        }
    }, [isReload]);

    useEffect(() => {
        if (webhooksenderlogid !== null) {
            if (isGuid(webhooksenderlogid)) {
                dispatch(getHeadingAsync(webhooksenderlogid));
                let SearchParamsValues = `${optionStatusValue},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${optionWebHookEventTypeValue}`;
                dispatch(getAccountWebHookSenderLogAsync());
            }
            else {
                navigate('/webHooks');
            }

        }
        else {
            navigate('/webHooks');
        }
    }, [dispatch]);

    const onViewDetailClick = (AccountWebhookSenderLogId: string) => {
        dispatch(getWebHookSenderLogAsync(AccountWebhookSenderLogId))
            .unwrap()
            .then((originalPromiseResult) => {
                onhandleFilterOnClickEvent(offCanvasObject);
            })
            .catch((rejectedValueOrSerializedError) => {
            })
    }

    const handleCheckboxChange = (e: any, rowId: any) => {
        if (e.target.checked) {
            dispatch(checkedState(rowId))
        } else {
            dispatch(unCheckedState(rowId))
        }
    };

    // const handleSort = (Index: number) => {
    //     const Dir = Index === sortIndex && sortDirection === 'asc' ? 'desc' : 'asc';
    //     dispatch(setSortConfig({ Index, Dir }));
    // };

    const handleSelectAllChange = (e: any) => {
        const { checked } = e.target;
        if (checked) {
            dispatch(checkedAllState());
        } else {
            dispatch(unCheckedAllState());
        }
    };
    const onHandleSorting = (sortOrder: string, sortColumn: string) => {
        let objects = {
            "sortOrder": sortOrder,
            "sortColumn": sortColumn,
            "startRec": 0,
            "pageSize": pageSize,
            "pageNo": 1
        }
        dispatch(updateSorting(objects));
    }

    return (
        <>
         {/* {isLoading && (
                <div className="spinner-overlay">
                    <div className="spinner"></div>
                </div>
            )} */}
            <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle" >
                    <th style={{ width: '5%' }}>
                            <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    checked={WebHookSenderLogList.filter(item => item.StatusCode !== 200 && item.StatusCode !== 202 && item.StatusCode !== 201).every((item) => item.isSelected === 0) ? false :
                                        (WebHookSenderLogList.filter(item => item.StatusCode !== 200 && item.StatusCode !== 202 && item.StatusCode !== 201).every((item) => item.isSelected === 1 ? true : false))
                                    }
                                    onChange={handleSelectAllChange}
                                />

                            </div>
                        </th>
                        <th style={{ width: '20%' }}>
                            {/* {t('Trigger Date')} */}
                            {getValueFromResource('Trigger Date',dispatch, t)}
                            {sortColumn === '0' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "0") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "0") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "0") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "0") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Status')} */}
                            {getValueFromResource('Status',dispatch, t)}
                            {sortColumn === '1' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "1") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "1") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        <th style={{ width: '15%' }}>
                            {/* {t('Status Code')} */}
                            {getValueFromResource('Status Code',dispatch, t)}
                            {sortColumn === '2' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "2") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "2") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        <th style={{ width: '20%' }}>
                            {/* {t('Webhook Event Type')} */}
                            {getValueFromResource('Webhook Event Type',dispatch, t)}
                            {sortColumn === '3' ?
                                sortOrder === 'asc' ? <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                    <i className="ki-outline ki-arrow-up sortIconColor fs-5 sortMT"></i>
                                </span> : <span className="headerSortIconBG cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                    <i className="ki-outline ki-arrow-down sortIconColor fs-5 sortMT"></i>
                                </span>
                                :
                                // hoveredColumn === 1 && 
                                <><span className="cursor" onClick={() => { onHandleSorting("asc", "3") }}>
                                    <i className="bi bi-sort-up fs-6 headerSortIcon">
                                        <span className="path1"></span>
                                        <span className="path2"></span>
                                    </i>
                                </span>
                                    <span className="cursor" onClick={() => { onHandleSorting("desc", "3") }}>
                                        <i className="bi bi-sort-down fs-6 headerSortIcon">
                                            <span className="path1"></span>
                                            <span className="path2"></span>
                                        </i>
                                    </span>
                                </>}

                        </th>
                        <th className='w-50px'></th>
                    </tr>
                </thead>
                <tbody>
                    {WebHookSenderLogList.length > 0 && WebHookSenderLogList.map((WebHookSenderLogDetail: any, i: any) => (
                        <tr key={i}>
                            {(WebHookSenderLogDetail.StatusCode == 200 || WebHookSenderLogDetail.StatusCode == 202 || WebHookSenderLogDetail.StatusCode == 201) ?
                                <td></td>
                                :
                                <td>
                                    <div className='form-check form-check-sm form-check-custom form-check-solid small-checkbox' >
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={WebHookSenderLogDetail.isSelected == 0 ? false : true}
                                            onChange={e => handleCheckboxChange(e, WebHookSenderLogDetail.AccountWebhookSenderLogId)}
                                        />
                                    </div>
                                </td>
                            }
                            <td>
                                <span className="d-block">
                                    {WebHookSenderLogDetail.TriggerDate}
                                </span>
                            </td>
                            <td>
                                {(WebHookSenderLogDetail.TriggerStatus === 'Fail' || WebHookSenderLogDetail.TriggerStatus === 'fail')
                                    ? <span className="badge badge-light-danger fs-7">{WebHookSenderLogDetail.TriggerStatus}</span>
                                    : (WebHookSenderLogDetail.TriggerStatus === 'Success') ? <span className="badge badge-light-success fs-7">{WebHookSenderLogDetail.TriggerStatus}</span>
                                        : <span className="badge badge-light-primary fs-7">{WebHookSenderLogDetail.TriggerStatus}</span>
                                }
                            </td>
                            <td>
                                <span className="d-block">
                                    {WebHookSenderLogDetail.StatusCode}
                                </span>
                            </td>
                            <td>
                                <span className="d-block">
                                    {WebHookSenderLogDetail.SystemWebhookEventTypeCaption}
                                </span>
                            </td>
                            <td className='text-end'>
                                <div className='d-flex justify-content-center flex-shrink-0'>
                                    <a id="kt_OffCanvas" className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        onClick={() => { onViewDetailClick(WebHookSenderLogDetail.AccountWebhookSenderLogId) }}>
                                        <i className="bi bi-receipt fs-3"></i>
                                    </a>
                                </div>
                            </td>
                               <td colSpan={6}><p className='noDataFound mt-3'>
                                                    {/* {t('No Record Found')} */}
                                                    {getValueFromResource('No Record Found',dispatch, t)}
                            
                                                    </p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    )
}

export default WebHookSenderLogItem
